import React, { useRef } from 'react';
import { Box, styled } from '@mui/material';
import TabContent from '../../atoms/tab/TabContent';
import Title from '../../atoms/title/Title';
import HpTooltip from '../../atoms/tooltip/HpTooltip';
import { ITabContentProps } from '../../commons/types';
import FunctionVLTable from '../../organisms/tables/VariableLibrary/FunctionVLTable';
import { MRT_TableInstance } from 'material-react-table';
import SubTitle from '../../atoms/title/SubTitle';
import ResetButton from '../../atoms/button/ResetButton';
import Button from '../../atoms/button/Button';
import { useActions } from '../../hooks/actions';
import FunctionVLModal from '../../organisms/modals/VariableLibrary/FunctionVLModal';
import { useGetFunctionsListQuery } from '../../store/api/leadership';

const StyledTitlesWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

const StyledTitleWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const StyledHeaderWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const StyledSubHeaderWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const StyledHeaderActionWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  gap: '15px',
});

const Functions = ({ index, value }: ITabContentProps) => {
  const { data: { data } = {}, isLoading } = useGetFunctionsListQuery('Master');

  const tableInstanceRef = useRef<MRT_TableInstance>(null);

  const onResetButtonClick = (): void => {
    tableInstanceRef.current !== null &&
      tableInstanceRef.current.resetColumnFilters();
  };

  const { openAddFunctionModal } = useActions();

  return (
    <TabContent
      index={index}
      value={value}
    >
      <FunctionVLModal />
      <StyledTitlesWrapper>
        <StyledTitleWrapper>
          <StyledHeaderWrapper>
            <Title
              text={'Functions'}
              sx={{ fontSize: '28px' }}
            />
            <Box>
              <HpTooltip title={' '} />
            </Box>
          </StyledHeaderWrapper>
          <StyledHeaderActionWrapper>
            <Button
              btnType={'PRIMARY'}
              text={'Add new function'}
              onClick={() => openAddFunctionModal()}
            />
          </StyledHeaderActionWrapper>
        </StyledTitleWrapper>
        <StyledSubHeaderWrapper>
          <SubTitle
            text={`${data?.length ? data?.length : '0'} total functions`}
          />
          <ResetButton
            onClick={onResetButtonClick}
            text='Reset'
          />
        </StyledSubHeaderWrapper>
      </StyledTitlesWrapper>
      <FunctionVLTable
        data={data}
        isLoading={isLoading}
        tableInstanceRef={tableInstanceRef}
      />
    </TabContent>
  );
};

export default Functions;
